<template>
  <div class="meter-list">
    <div class="search-wrap">
      <el-button size="mini" @click="search">查询</el-button>
      <el-button size="mini" @click="edit()" style="margin-right: 5px;" icon="el-icon-plus"  v-if="ERP.isPermission(4007002001)||ERP.isPermission(21004001001)||ERP.isPermission(8006001001)">添加</el-button>
      <!-- <el-button size="mini">批量</el-button> -->
<!--      <el-button size="mini" @click="navToMeterExcel" v-if="(ERP.isPermission(4007002002)||ERP.isPermission(21004001002)||ERP.isPermission(8006001002))">导入</el-button>-->
      <!--          <el-button size="mini" v-if="multipleSelection.length">生成二维码（选中）</el-button>-->
      <!--          <el-button size="mini">生成二维码（全部）</el-button>-->
      <!--          <el-button size="mini" v-if="multipleSelection.length">打印二维码（选中）</el-button>-->
      <!--          <el-button size="mini">打印二维码（全部）</el-button>-->
      <!--          <el-button size="mini">导出EXCEL</el-button>-->
      <el-button size="mini" v-if="multipleSelection.length&&multipleSelection_meter_type_num===1 && (ERP.isPermission(4007002004)||ERP.isPermission(21004001004)||ERP.isPermission(8006001004))" @click="updateChargingStandard">批量修改收费标准</el-button>
      <el-button size="mini" v-if="multipleSelection.length && (ERP.isPermission(4007002005)||ERP.isPermission(21004001005)||ERP.isPermission(8006001005))" @click="stopUse(2)">部分停用</el-button>
      <el-button size="mini" v-if="multipleSelection.length && (ERP.isPermission(4007002005)||ERP.isPermission(21004001005)||ERP.isPermission(8006001005))" @click="stopUse(1)">部分启用</el-button>
      <el-button size="mini" v-if="(ERP.isPermission(4007002005)||ERP.isPermission(21004001005)||ERP.isPermission(8006001005))" @click="allUpdate({status:2})">全部停用</el-button>
      <el-button size="mini" v-if="(ERP.isPermission(4007002005)||ERP.isPermission(21004001005)||ERP.isPermission(8006001005))" @click="allUpdate({status:1})">全部启用</el-button>
<!--      <el-button size="mini" v-if="(ERP.isPermission(4007002005)||ERP.isPermission(21004001005)||ERP.isPermission(8006001005))" @click="goToMeterDiagram">架构图</el-button>-->
      <el-button type="danger" size="mini" icon="el-icon-delete" v-if="multipleSelection.length && (ERP.isPermission(4007002003)||ERP.isPermission(21004001003)||ERP.isPermission(8006001003))" @click="dels()">删除</el-button>

<!--      <el-button size="mini" icon="el-icon-info" @click="openViewFile(host_url+'/word_template/yi_biao_guan_li_chao_zuo_zhi_yin.docx','仪表管理操作指引')">仪表操作指引</el-button>-->
      <el-button size="mini" @click="exportQrcode">导出二维码</el-button>
    </div>

    <div style="margin-bottom: 10px;">
      <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'43%'}">
        <el-descriptions-item label="仪表类型">
          <el-select size="mini" style="width: 100%" v-model="where.meter_type" clearable filterable placeholder="类型" class="kuan" @change="pageChange(1)">
            <el-option v-for="item in meter_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="当前房产">
          <el-input size="mini" placeholder="请选择房产" v-model="where.house_name" clearable @change="pageChange(1)"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="仪表编号">
          <el-input size="mini" placeholder="请输入仪表编号" v-model="where.number" @change="pageChange(1)" clearable></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="收费标准">
          <el-select size="mini" style="width: 100%" v-model="where.charging_standard" filterable clearable placeholder="收费标准" class="kuan" @change="pageChange(1)">
            <el-option v-for="item in house_charge_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="仪表名称">
          <el-input size="mini" placeholder="请输入仪表名称" v-model="where.name" clearable @change="pageChange(1)"></el-input>
        </el-descriptions-item>
<!--        <el-descriptions-item label="线路">-->
<!--          <el-input size="mini" placeholder="请输入收费对象" v-model="where.line" clearable></el-input>-->
<!--        </el-descriptions-item>-->
        <el-descriptions-item label="更换的收费标准">
          <el-select size="mini" style="width: 100%" v-model="charging_standard" filterable clearable placeholder="更换的收费标准" class="kuan">
            <el-option v-for="item in house_charge_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-descriptions-item>
<!--        <el-descriptions-item label="仪表等级">-->
<!--          <el-checkbox-group v-model="where.meter_level" @change="pageChange(1)">-->
<!--            <el-checkbox v-for="item in [{name:'一级',val:1},{name:'二级',val:2},{name:'三级',val:3},{name:'四级',val:4}]" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>-->
<!--          </el-checkbox-group>-->
<!--        </el-descriptions-item>-->
<!--        <el-descriptions-item label="仪表归属">-->
<!--          <el-select size="mini" style="width: 100%" v-model="where.meter_tag" clearable filterable multiple placeholder="类型" class="kuan" @change="pageChange(1)">-->
<!--            <el-option v-for="item in meter_tag_list" :key="item.id" :label="item.name" :value="item.id"></el-option>-->
<!--          </el-select>-->
<!--        </el-descriptions-item>-->
        <el-descriptions-item label="仪表状态">
          <el-checkbox-group v-model="where.status_ids" @change="pageChange(1)">
            <el-checkbox v-for="item in [{name:'在用',val:1},{name:'停用',val:2}]" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-descriptions-item>
        <el-descriptions-item label="仪表性质">
          <el-checkbox-group v-model="where.meter_nature_ids" @change="pageChange(1)">
            <el-checkbox v-for="item in meter_nature_list" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-descriptions-item>
        <el-descriptions-item label="能耗类型">
          <el-checkbox-group v-model="where.energy_ids" @change="pageChange(1)">
            <el-checkbox v-for="(item,index) in energy_list" :disabled="!isEnergyAble(item.val)" :label="item.val" :key="index">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-descriptions-item>
        <el-descriptions-item label="虚表类型">
          <el-checkbox-group v-model="where.meter_virtually" @change="pageChange(1)">
            <el-checkbox v-for="item in [{name:'实表',val:1},{name:'虚表',val:2},{name:'固定金额表',val:3}]" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <div>
      <el-table v-if="pageData" v-loading="loading" border :data="pageData.list" width="99%" height="calc(100vh - 520px)"  @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
<!--        <el-table-column prop="id" label="id" width="80"></el-table-column>-->
        <el-table-column prop="number" label="仪表编号 "  width="150" fixed>
          <template slot-scope="scope">
            <el-link type="primary" @click="edit(scope.row)">{{scope.row.number||'无仪表编号'}}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="meter_level" label="仪表等级"  width="100">
          <template slot-scope="scope">
            {{meter_level_obj[scope.row.meter_level]||''}}
          </template>
        </el-table-column>
        <el-table-column prop="house_name" label="房产" width="300"></el-table-column>
        <el-table-column prop="meter_type_name" label="仪表类型" width="100"></el-table-column>
        <el-table-column prop="name" label="仪表名称 " width="250"></el-table-column>
<!--        <el-table-column prop="line" label="线路 " width="100"></el-table-column>-->
        <el-table-column prop="charging_standard_name" label="收费标准 "  width="250"></el-table-column>
        <el-table-column prop="charging_standard_money" label="费用单价 "  width="100"></el-table-column>
        <el-table-column prop="status" label="是否在用 " width="100">
          <template slot-scope="scope">
            {{scope.row.status===1?'启用':'停用'}}
          </template>
        </el-table-column>
        <el-table-column label="操作 " width="280" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="updateEdit(scope.row)" v-if="ERP.isPermission(4007002007)||ERP.isPermission(21004001007)||ERP.isPermission(8006001007)||ERP.isPermission(30006001007)">换表</el-button>
            <el-button type="primary" size="mini" icon="el-icon-share" @click="showMapNode(scope.row)">线路图</el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="meterShifting(scope.row)" v-if="ERP.isPermission(4007002008)||ERP.isPermission(21004001008)||ERP.isPermission(8006001008)||ERP.isPermission(30006001008)">移表</el-button>

          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 20px;text-align: center;margin-right: 20px;display: flex;flex-direction: row;align-items: center;justify-content: center;">
      <el-input v-model="pageData.pageSize" placeholder="每页显示条数" @change="pageChange(1)" style="width: 80px;" size="mini"></el-input>
      <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
    </div>

    <MeterShifting ref="MeterShiftingRef" />

    <ViewFile ref="ViewFile" />

    <MeterEditor ref="MeterEditorRef" />

    <MeterReplace ref="MeterReplace" />

    <MeterMapNodeEditor ref="MeterMapNodeEditorRef" />


  </div>
</template>

<script>
import ErpTree from "../../../Common/erp-tree";
import UploadFilesSysc from "../../../Contract/components/UploadFilesSysc";
import ErpTreeStatus from "../../../Common/erp-tree-status";
import MapSearch from "../../../Common/MapSearch";
import MeterShifting from "./components/MeterShifting";
import ViewFile from "../../../Common/ViewFile";
import MeterEditor from "./components/MeterEditor";
import MeterMapNodeEditor from "./components/MeterMapNodeEditor";
import CommonMixin from "../../common/CommonMixin";
import MeterHttp from "../../common/MeterHttp";
import MeterReplace from "./components/MeterReplace";

export default {
  name: "MeterList",
  components: {
    MeterReplace,
    MeterMapNodeEditor,
    MeterEditor, ViewFile, MeterShifting, MapSearch, ErpTreeStatus, UploadFilesSysc, ErpTree},
  mixins:[CommonMixin],
  inject:['mainObj','componentId','setComponentId'],
  data() {
    return {
      host_url: "",
      keyword: '',
      loading: false,
      where: {
        meter_type: "",
        house_name: "",
        number: "",
        charging_standard: "",
        status: "",
        status_ids: [1,2],
        line: "",
        meter_nature: "",
        meter_nature_ids: [1,2,3,4],
        name: "",
        energy_ids:this.getDefaultEnergyIds(),
        meter_virtually:[1],
        // meter_level:[1,2,3,4],
        // meter_tag:[1,2,3,4]
      },
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1
      },
      treeDialogVisible: false,
      form: {
        pid:'',
        upid:'',
        p_name:'',
        name: "",
        number: "",
        project_id: "",
        house_id: "",
        house_name: "",
        house_number: "",
        meter_number: "",
        meter_type: "",
        charge_type: "",
        charging_standard: "",
        sort: "0",
        status: 1,
        meter_nature: 1,
        magnification: 1,
        start_number: 0,
        return_trip: "",
        install_time: "",
        reading_time: "",
        position: "",
        lat: "",
        lng: "",
        files: "",
        line: "",
        specifications: "",
        remarks: "",
        is_update:0,
        energy:1,
        energy_nature:"1",
        fixed_amount:'',
      },
      uploadUrl: "",
      month_value: "",
      business_list: [],
      entry_type_name: "",
      multipleSelection: [],
      meter_type_list: [],
      house_charge_list:[],
      chargeItem_name_ids:"",
      meter_nature_list:[{name:'分表',val:1},{name:'总表',val:2},{name:'分摊表',val:3},{name:'电力负荷表',val:4}],
      energy_list:[{name:"业主能耗",val:1},{name:"物业能耗",val:2},{name:"分摊能耗",val:3},],
      charging_standard:"",
      mapDialogTableVisible:false,
      yDialogVisible:false,
      mapCenter:[0,0],
      energyArray:{
        id:'',
        number:'',
        name:'',
        meter_type:'',
        meter_nature:'',
        energys:'',
        energy_nature:'',
      },
      last_mater_note:{},
      meter_level_obj:{1:"一级",2:"二级",3:"三级",4:"四级",5:"五级"},
      meter_tag_list:[{id:1,name:"电梯仪表"},{id:2,name:"照明仪表"},{id:3,name:"水泵仪表"},{id:4,name:"消控室仪表"}]
    }
  },
  mounted() {
    const that=this;
    this.host_url = __HTTP__.defaults.baseURL;
    // this.month_value=CommonHelp.date("YYYY-MM");

    that.getMeterTypeList()
    that.form.project_id = that.mainObj.project_id;
    that.form.house_name = that.mainObj.house_name;
    that.form.house_id = that.mainObj.house_id;
    that.where.house_name=that.mainObj.house_name;
    if(that.mainObj.house_name){
      that.getList();
    }
  },
  watch: {
    "form.meter_nature"(val){
      if(this.form.meter_nature == 3){
        this.form.energys = "3";
      }else{
        this.form.energys = "1";
      }
      this.form.energy_nature = '';

    },
    "form.energys"(val){
      this.form.energy_nature = '';
    },
    "form.project_id":function (n) {
      this.getHouseChargeList();
    },
    "form.meter_type":function (n) {
      this.chargeItem_name_ids=(this.meter_type_list.find(ret=>{ return ret.id===n })||{}).expenditure_ids||"";
      this.getHouseChargeList();
    },
    "where.meter_type":function (n) {
      this.chargeItem_name_ids=(this.meter_type_list.find(ret=>{ return ret.id===n })||{}).expenditure_ids||"";
      this.getHouseChargeList();
    },
    "mainObj.house_name":function (n) {
      const that=this;
      this.form.project_id = that.mainObj.project_id;
      this.form.house_name = n;
      this.form.house_id = that.mainObj.house_id;
      this.where.house_name=n;
      this.getList();
    }
  },
  computed: {
    multipleSelection_meter_type_num(){
      let set=new Set();
      this.multipleSelection.map(ret=>{
        set.add(ret.meter_type)
      });
      return Array.from(set).length;
    }
  },
  methods: {
    getFormData(data) {
      return Object.assign({
        pid:'',
        upid:'',
        p_name:'',
        name: "",
        number: "",
        project_id: "",
        house_id: "",
        house_name: "",
        house_number: "",
        meter_number: "",
        meter_type: "",
        charge_type: "",
        charging_standard: "",
        sort: "0",
        status: 1,
        meter_nature: 1,
        magnification: 1,
        start_number: 0,
        return_trip: "",
        install_time: "",
        reading_time: "",
        position: "",
        lat: "",
        lng: "",
        files: "",
        line: "",
        specifications: "",
        remarks: "",
        is_update:0,
        energy:1,
        energy_nature:"1",
        fixed_amount:'',
      }, data)
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      const that = this;
      that.loading = true;
      let where = reObject(this.where);
      // where.is_update=0;
      MeterHttp.get("Meter/getList",{
        project_id:that.mainObj.project_id,
        where: JSON.stringify(where),
        user_type:(that.$route.query.type||0),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      }, res => {
        console.log(res);
        if (res.code) {
          that.pageData = res.data
        }
        that.loading = false;
        that.multipleSelection = []
      });
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    edit(item=null) {
      if (!item) {
        let project_id= this.form.project_id
        let house_id= this.form.house_id
        let house_name= this.form.house_name
        this.form = this.getFormData({})
        this.form.project_id=project_id;
        this.form.house_id=house_id;
        this.form.house_name=house_name;
      } else {
        this.form = reObject(item);
      }
      this.$refs.MeterEditorRef.show(reObject(item))
    },

    meterShifting(item) {
      this.$refs.MeterShiftingRef.show(reObject(item))
    },

    updateEdit(item) {
      if (!item) {
        this.$message.error('无数据')
        return false;
      }
      this.$refs.MeterReplace.show(item);
    },

    setFrom(data){
      const that = this;
      MeterHttp.post("Meter/save?user_type="+(that.$route.query.type||0),data, res => {
        that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
        if (res.code) {
          that.getList()
        }
      });
    },
    del(item) {
      const that = this;
      MeterHttp.post("Meter/delete?user_type="+(that.$route.query.type||0),{
        project_id:that.mainObj.project_id,
        id: item.id,
      }, res => {
        that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
        if (res.code) {
          that.getList()
        }
      })
    },
    dels() {
      const that = this;
      MeterHttp.post("Meter/delete?user_type="+(that.$route.query.type||0),{
        project_id:that.mainObj.project_id,
        ids: this.multipleSelection.map(ret => {
          return ret.id
        }).join(','),
      },res => {
        that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
        if (res.code) {
          that.getList()
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    nodeClick(data) {
      let tree_str = data.tree.map(ret => {
        return ret.name
      }).join('->');
      //console.log(data);
      this.form.project_id = data.tree[0].pindex_id;
      this.form.house_name = tree_str;
      this.form.house_id = data.tree[data.tree.length - 1].house_id;
      this.where.house_name=tree_str;
      this.getList();
    },
    getMeterTypeList(){
      const that = this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        field:"id,name,expenditure_ids,expenditure_name",
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      });
    },
    getHouseChargeList(){
      const that = this;
      let where={};
      this.form.project_id&&(where.pindex_id=this.form.project_id);
      this.chargeItem_name_ids&&(where.chargeItem_name_ids=this.chargeItem_name_ids);
      ERP.getRequest({
        url:"admin/HouseCharge/getList",
        data:{
          project_id:that.mainObj.project_id,
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_list=ret.data.list;
        }
      });
    },
    showMapDialogTableVisible(){
      this.mapDialogTableVisible=true
    },
    navToMeterExcel(){
      ERP.navigateTo("/meter/meterExcel?type="+(this.$route.query.type||0));
    },
    stopUse(status=1){
      const that = this;
      that.$confirm('您确定停用该仪表吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.setFrom({
          ids:that.multipleSelection.map(ret=>{ return ret.id }),
          status:status
        });
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '取消'
        });
      });
    },
    updateChargingStandard(){
      var that=this;
      that.$confirm('您确定修改该仪表收费标准吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.setFrom({
          ids:that.multipleSelection.map(ret=>{ return ret.id }),
          charging_standard:that.charging_standard,
        });
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '取消'
        });
      });

    },
    goToMeterDiagram(){
      ERP.navigateTo("/meter/MeterDiagram?type="+(this.$route.query.type||0));
    },
    allUpdate(data={}) {
      const that = this;
      let where = reObject(this.where);
      MeterHttp.post("Meter/allUpdate",{
        project_id:that.mainObj.project_id,
        where: JSON.stringify(where),
        user_type:(that.$route.query.type||0),
        data: data,
      }, res => {
        if (res.code) {
          that.$message.success(res.msg||'修改成功')
          that.getList()
        }else {
          that.$message.success(res.msg||'修改失败')
       }
      });
    },
    openViewFile(src,title){
      const that=this;
      that.$refs.ViewFile.show({
        width: '90vw',
        height:'80vh',
        title:title,
        src:src,
        download(){
          // TODO 下载文件逻辑
          window.open(src)
        }
      })
    },
    showMapNode(item){
      // this.$refs.MeterMapNodeEditorRef.show(item.id);
      window.open("/#/show/MeterMapEditor?meterId="+item.id+"&projectId="+item.project_id+"&type="+this.$route.query.type)
    },
    exportQrcode(){
      const that=this;
      if(!that.mainObj.project_id){
        that.$message.error("请先选择项目");
        return false;
      }
      let ids=that.multipleSelection.map(ret=>{ return ret.id }).join(',');
      window.open(`https://meter.gdzawy.com:9001/meter/MeterQr/getProjectQrCode?project_id=${that.mainObj.project_id}&ids=${ids}&type=${that.$route.query.type||0}`)
    }
  }
}

function reObject(item) {
  return JSON.parse(JSON.stringify(item));
}
</script>

<style lang="scss" scoped>
@import "../../common";
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/MeterList.vue